import { render } from "./partnerTr.vue?vue&type=template&id=371df6f0&scoped=true"
import script from "./partnerTr.vue?vue&type=script&lang=js"
export * from "./partnerTr.vue?vue&type=script&lang=js"

import "./partnerTr.vue?vue&type=style&index=0&id=371df6f0&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371df6f0"]])

export default __exports__